<template>
  <ul
    id="content-list"
    class="page-list p-0 mx-5 mb-5">
    <!-- Content Groups -->
    <li
      v-for="(content, contentGroup) in contentGrouped"
      :key="contentGroup">
      <header class="section-header">{{contentGroup | startCase}}</header>

      <!-- Content For Group -->
      <ul class="p-0">
        <li
          class="page-list-item"
          v-for="c in content"
          :key="c.contentId"
          >
          <div
            class="d-flex align-stretch content-max-height">
            <!-- Content ID -->
            <div class="content-id">
              {{contentItemInfo(c.contentId).element}}
            </div>
            <!-- / Content ID -->

            <!-- Non-Color Content -->
            <div
              class="content-content">
              <!-- Settings Content -->
              <div
                v-if="c.type === 'settings' && c.content !== null && c.content.startsWith('http')">
                <div
                  v-if="c.content"
                  v-html="c.content"
                  @click="handleUrlRedirect(c.content)"
                  >
                </div>
                <small
                  v-else
                  class="font-italic text--secondary">
                  not defined
                </small>
              </div>
              <!-- / Settings Content -->
              <!-- Settings Content -->
              <div
                v-else>
                <div
                  v-if="c.content"
                  v-html="c.content">
                </div>
                <small
                  v-else
                  class="font-italic text--secondary">
                  not defined
                </small>
              </div>
              <!-- / Settings Content -->
            </div>
            <!-- / Content Contents -->
          </div>
          <v-divider></v-divider>
        </li>
      </ul>
      <!-- / Content For Group -->
    </li>
    <!-- / Content Groups -->
  </ul>
</template>

<script>
import _ from 'lodash';
import ContentItemMixin from '../mixin.content-item';

export default {
  name: 'ProjectSettingsList',
  mixins: [
    ContentItemMixin,
  ],
  computed: {
    contentGrouped() {
      return _(this.$store.state.projectSettings)
        .groupBy((content) => content.contentId.split('.')[0])
        .value();
    },
  },
  methods: {
    handleUrlRedirect(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="scss">
#project-settings-list {
  .page-list-item {
    .content-id {
      width: 20%;
      padding: 7px 14px;
    }

    .content-content {
      width: 80%;
      padding: 7px 14px;
      overflow: hidden;
    }
  }
}
</style>
